import Layout from "@/components/Layout";
import CardRow from "@/components/card/CardRow";
import TravelGuideCard from "@/components/guide/components/TravelGuideCard";
import Button from "@/components/ui/buttons/Button/Button";
import { fetchLayoutData } from "lib/api/strapi-layout";
import { fetchTravelGuides } from "lib/api/strapi-travel-guide";
import useSWR from "swr";

import Hero from "@/components/content/Hero/Hero";
import SectionTitle from "@/components/typography/SectionTitle/SectionTitle";
import LoadingAnimation from "@/components/ui/loaders/LoadingAnimation/LoadingAnimation";
import { gql } from "@apollo/client";
import { graphQlClient } from "lib/graphql-client";
import styles from "./TravelGuides.module.scss";

export default function TravelGuides({ layoutData, guides, seo, images }) {
  // const fetcher = (url) =>
  //   fetch(url).then((response) => {
  //     return response.json();
  //   });

  // const { data: guides } = useSWR("/api/travel-guides?limit=50", fetcher, {
  //   revalidateOnMount: true,
  //   fallbackData: initialGuides,
  // });

  const guideCards = !!guides
    ? guides
        .filter((guide) => {
          return guide?.seo?.metaTitle && guide?.seo?.metaMedia?.url;
        })
        .map((guide) => {
          return (
            <TravelGuideCard
              key={`${guide?.slug}-${guide?.author?.id}-${guide?.id}`}
              guide={guide}
            />
          );
        })
    : [];

  return (
    <Layout layoutData={layoutData} seo={seo}>
      <Hero
        images={images ?? []}
        title="Where do you want to go?"
        link="/travel-guides/create"
        buttonText="Create Your Free Travel Guide"
      />
      <main className={`${styles.container} variable-container`}>
        <h1 className={`${styles.pageTitle}`}>
          <SectionTitle title="Travel Guides" />
        </h1>
        {!guideCards ||
          (guideCards?.length === 0 && (
            <div className={`${styles.loadingWrapper}`}>
              <LoadingAnimation />
            </div>
          ))}
        {guideCards && (
          <CardRow
            cards={guideCards}
            seeAll={false}
            justify="center"
            sideScrollButtons={false}
            scrollIndicator={false}
          />
        )}
      </main>
    </Layout>
  );
}

export async function getStaticProps() {
  const guides = await fetchTravelGuides({ limit: 100 });
  const filteredGuides = await guides?.filter((guide) => {
    return guide?.seo?.metaTitle && guide?.seo?.metaMedia?.url;
  });
  // const filteredGuides = guides;

  const strapiApolloClient = graphQlClient();

  let guidePageData = await strapiApolloClient.query({
    query: gql`
      query travelGuidePage {
        travelGuidePage {
          data {
            attributes {
              search_engine_optimization {
                metaTitle
                metaDescription
                metaMedia {
                  data {
                    attributes {
                      alternativeText
                      url
                    }
                  }
                }
              }
              hero_images {
                data {
                  attributes {
                    url
                    alternativeText
                    width
                    height
                    name
                  }
                }
              }
            }
          }
        }
      }
    `,
  });

  const search_engine_optimization =
    guidePageData?.data?.travelGuidePage?.data?.attributes
      ?.search_engine_optimization;

  const seo = {
    ...search_engine_optimization,
    metaMedia: search_engine_optimization?.metaMedia?.data?.attributes ?? null,
  };

  const layoutData = await fetchLayoutData();

  return {
    props: {
      guides: filteredGuides ?? [],
      layoutData,
      seo,
      images:
        guidePageData?.data?.travelGuidePage?.data?.attributes?.hero_images?.map(
          (image) => image?.data?.attributes
        ) ?? null,
    },
    revalidate: 60,
  };
}
